import styled from 'styled-components';
import { Box } from 'rebass/styled-components';

export interface MultilineTextWithEllipsisProps {
  lineCount: number;
  maxWidth?: number;
}

const MultilineTextWithEllipsis = styled(Box)<MultilineTextWithEllipsisProps>`
  max-width: ${({ maxWidth }: MultilineTextWithEllipsisProps) => maxWidth}px;
  display: -webkit-box;
  -webkit-line-clamp: ${({ lineCount }: MultilineTextWithEllipsisProps) => lineCount};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export default MultilineTextWithEllipsis;
